import EnvironmentType from './EnvironmentType';
import brands from './brands';
import BrandGroup from './BrandGroup';
export const getBrand = (siteId) => brands.find((brand) => brand.siteId === siteId);
export function getCurrentBrand(url) {
    const currentBrand = brands.filter((brand) => {
        return url.match(new RegExp(brand.hostPattern)) != null;
    });
    if (currentBrand.length !== 1) {
        if (currentBrand.length === 2) {
            return determineIfJobsite(currentBrand);
        }
        return null;
    }
    return currentBrand[0];
}
export function determineIfJobsite(currentBrands) {
    const brand = currentBrands.find((x) => x.hostPattern == 'www.jobsite');
    return brand == undefined ? null : brand;
}
export function getBaseUrlForJobsiteBrands(url, brand) {
    if (brand.brandGroup !== BrandGroup.Jobsite) {
        throw new Error(`${brand.name} is not a jobsite brand`);
    }
    if (url.indexOf('.io') > -1) {
        return `https://${url.replace(brand.hostPattern, 'www.totaljobs')}`;
    }
    return 'https://www.totaljobs.com';
}
export const determinePublicBaseUrl = (environment, brand, teamName = '') => {
    if (environment === EnvironmentType.development && !teamName) {
        throw new Error(`Team name is not defined`);
    }
    if (brand.brandGroup === BrandGroup.Stepstone) {
        return buildBaseUrlForStSt(brand, environment, teamName);
    }
    return buildBaseUrlForTJG(environment, brand, teamName);
};
const buildBaseUrlForStSt = (brand, environment, teamName) => {
    switch (environment) {
        case EnvironmentType.development:
            return `https://${teamName}-team${brand.hostPattern}`;
        case EnvironmentType.next:
        case EnvironmentType.uat:
            return `https://next${brand.hostPattern}`;
        case EnvironmentType.live:
            return `https://www${brand.hostPattern}`;
        default:
            throw new Error('Please specify a valid environment');
    }
};
const buildBaseUrlForTJG = (environment, { devHostPattern, hostPattern, liveDomainExtension }, teamName) => {
    const cleanHostPattern = hostPattern.match(/^(w{3}.[a-z]+)/g)?.[0];
    const testHostPattern = devHostPattern || cleanHostPattern;
    switch (environment) {
        case EnvironmentType.development:
            return `https://${testHostPattern}.${teamName}.tjgdev.io`;
        case EnvironmentType.next:
        case EnvironmentType.uat:
            return `https://${testHostPattern}.tjgpat.io`;
        case EnvironmentType.live:
            return `https://${cleanHostPattern}${liveDomainExtension}`;
        default:
            throw new Error('Please specify a valid environment');
    }
};
//# sourceMappingURL=brandHelpers.js.map